import { createReducer, on } from '@ngrx/store';
import { AppSettingsApiActions } from './app-settings.actions';
import { adapter, initialState } from './app-settings.state';

export const categoryAppSettingsReducer = createReducer(
  initialState,
  on(AppSettingsApiActions.appSettingsLoaded, (state, { settings }) => adapter.upsertMany(settings, state)),
  on(AppSettingsApiActions.appSettingsUpdated, (state, { categoryType, categoryId, bundleIdentifier, settings }) => {
    // Make sure we first remove all old settings for the given category.
    // This will ensure that we are only left with the new settings.
    const settingId = categoryType + categoryId + bundleIdentifier;
    const toRemove = state.ids.map((x) => x.toString()).filter((x) => x.startsWith(settingId));
    const intermediateState = adapter.removeMany(toRemove, state);
    return adapter.upsertMany(settings, intermediateState);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAppSettingsIds = selectIds;

export const selectAppSettingsEntities = selectEntities;

export const selectAllAppSettings = selectAll;
